import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Content, Form, FormSubmit, TextInputControl } from '@/core/components';

import { FacultySelectControl } from '../Nomen/Faculty/FacultySelectControl';
import { UserSelectControl } from '../Nomen/User/UserSelectControl';
import { DepartmentSchema } from './model/DepartmentSchema';

interface DepartmentFormProps extends FormSubmit<DepartmentSchema> {
  title: string;
}

export function DepartmentForm(props: DepartmentFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<DepartmentSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <TextInputControl<DepartmentSchema>
              name="name"
              label={t('departments.form.fields.name')}
              isSubmitting={isSubmitting}
            />
            <FacultySelectControl<DepartmentSchema>
              label={t('departments.form.fields.faculty')}
              name="faculty"
              isSubmitting={isSubmitting}
            />
            <UserSelectControl<DepartmentSchema>
              label={t('departments.form.fields.headOfDepartment')}
              name="headOfDepartment"
              isSubmitting={isSubmitting}
            />
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
